export const checkNameEmail = (obj, key) => {
    if (obj) {
        let dateSplit = obj["Date & Time"].split(" ")[0].split("-");
        let d1 = new Date(dateSplit[0], dateSplit[1] - 1, dateSplit[2]);
        let diff = Math.round(
            (new Date().getTime() - d1.getTime()) / (1000 * 60 * 60 * 24)
        );

        if (key === "Email") {
            return diff > 30 ? "gdpr@compliant.now" : obj["Email"];
        }
        else {
            return diff > 30 ? "11111111111" : obj[key];
        }
    }
};